webpackJsonp([3],{

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
const messages = {
  message: {
    appTitle: 'Faire une réclamation de bagage',
    headerLogoAlt: 'Damaged luggage',
    headerEmailIconAlt: 'Nous envoyer un e-mail',
    backButton: 'Retour',
    nextButton: 'Continuer',
    deleteButton: 'Supprimer',
    cancelButton: 'Annuler',
    yesButton: 'Oui',
    noButton: 'Non',
    backToStart: 'Retour au début',
    chatTitle: '',
    chatSubTitle: '',
    datePlaceholderText: 'Sélectionner une date',
    selectPlaceholderText: 'Sélectionner',
    formErrorTitle: 'Erreur dans le formulaire',
    formErrorMessage: 'Veuillez corriger toute erreur dans le formulaire pour continuer',
    gdpr: {
      nextButtonText: 'Poursuivre la réclamation'
    },
    claimType: {
      title: 'Comment pouvons-nous vous aider ?'
    },
    dataPreparation: {
      completeFormSentence: 'Veuillez vous assurer d\'avoir rempli un formulaire de douane et de l\'avoir placé dans la case à votre droite.',
      airportDeliverySentence: 'Sans une déclaration en douane dûment remplie, nous ne serons pas en mesure derécupérer vos bagages à l\'aéroport pour organiser la livraison.',
      pleaseContinue: 'Une fois terminé, veuillez cliquer sur « Continuer » pour continuer.',
    },
    boardingPassScan: {
      scanToGetStarted: 'Scannez votre carte d\'embarquement pour commencer',
      pleaseScanDescriptionText: 'Veuillez scanner le code-barres ou le QR code de votre carte d\'embarquement pour lancer la procédure de réclamation.',
      noBoardingPass: 'Vous n\'avez pas de carte d\'embarquement ?',
      enterFlightDetailsManually: 'Saisissez manuellement les détails du vol'
    },
    boardingPassConfirm: {
      weFoundFollowingDetails: 'Nous avons trouvé les détails suivants',
      name: 'Prénom',
      flightNumber: 'N° de vol',
      dateOfFlight: 'Date du vol',
      departureAirport: 'Aéroport de départ',
      arrivalAirport: 'Aéroport d\'arrivée',
      areAboveDetailsCorrect: 'Les détails ci-dessus sont-ils corrects?',
      yesProceedButton: 'Oui, continuer',
      noScanAgainButton: 'Non, scannez la carte à nouveau',
      enterFlightDetailsManually: 'Saisissez manuellement les détails du vol'
    },
    about: {
      title: 'À propos de vous',
      firstName: 'Prénom',
      surname: 'Nom',
      emailAddress: 'E-mail',
      phoneNumber: 'Téléphone',
      phoneNumber2: 'Téléphone 2',
      country: 'Pays',
      fiscalCode: 'Code fiscal',
      address: 'Adresse',
      addressLine1: 'Adresse ligne 1',
      addressLine2: 'Adresse ligne 2',
      addressLine3: 'Adresse ligne 3',
      nameOnDoorBuzzer: 'Nom sur la sonnette',
      city: 'Ville',
      county: 'Pays',
      postcode: 'Code postal',
      selectAddressPlaceholderText: 'Sélectionner une adresse',
      searchDifferentAddress: 'Rechercher une autre adresse',
      manualAddress: 'Saisir l\'adresse manuellement',
      editAddress: 'Modifier l\'adresse'
    },
    address: {
      homeAddressTitle: 'Adresse de domicile',
      tempAddressTitle: 'Adresse du séjour',
      differentAddress: 'Vous rendez-vous actuellement à une adresse temporaire ?',
      dateTempAddress: 'Dernière date de votre séjour à l’adresse temporaire',
      plannedTravel: 'Envisagez-vous de voyager bientôt ?',
      plannedTravelDate: 'Quand envisagez-vous de voyager ?'
    },
    flightDetails: {
      title: 'Détails du vol',
      bookingRef: 'N° de réservation',
      flightRef: 'N° de vol',
      flightDate: 'Date du vol',
      findAFlightButton: 'Rechercher un vol',
      findClaimButton: 'Find claim details',
      incidentLabel: 'L\'incident a-t-il été déclaré à l\'aéroport ?',
      pirRefLabel: 'Numéro PIR (numéro de référence du rapport)',
      pirRef: 'PIR',
      dateReported: 'Date de déclaration',
      flightFinderInProgress: 'Recherche du vol en cours',
      flightClaimInProgress: 'Recherche de la réclamation en cours...',
      findClaimErrorHeading: 'Nous n’avons pas trouvé les informations relatives à votre réclamation',
      findClaimErrorMessage: 'Veuillez vérifier les informations précédentes et réessayer. Si vous ne trouvez pas les informations relatives à votre réclamation, vous pouvez toujours soumettre manuellement le formulaire ci-dessous.',
      findClaimSuccessHeading: 'Votre réclamation a été trouvée avec succès',
      findClaimSuccessMessage: 'Continuez à soumettre votre réclamation ci-dessous',
      flightFinderSuccessHeading: 'Départ',
      flightFinderSuccessMessageJoiner: 'à',
      flightFinderErrorIconAlt: 'Erreur',
      flightFinderErrorHeading: 'Impossible de trouver votre vol',
      flightFinderErrorMessage: 'Veuillez vérifier les informations précédentes et réessayer. Si vous ne trouvez pas votre vol, vous pouvez quand même fournir ces informations, toutefois, le traitement de votre réclamation risque d\'être plus long.',
      flightFinderErrorCheckboxLabel: 'Envoyer ma réclamation avec les informations ci-dessus',
      clearFlightFinderIconAlt: 'Effacer',
      clearFlightFinderMessage: 'Effacer et rechercher un autre vol',
      arrivalAirport: 'Aéroport d\'arrivée',
      departureAirport: 'Aéroport de départ',
      workOrderNumber: 'Numéro de bon de travail',
      bookingRefIconAlt: 'Référence de la réservation ou numéro de bon de travail',
      bookingRefInfoHeader: 'Référence de la réservation ou numéro de bon de travail',
      bookingRefInfoParagraph: 'Certaines compagnies aériennes peuvent vous donner un numéro de bon de travail au lieu d\'une référence de réservation.'
    },
    addClaimsItem: {
      title: 'Ajouter un article endommagé',
      itemTypeLabel: 'Type de réclamation',
      baggageButton: 'Bagage',
      contentsButton: 'Contenus',
      addToClaimButton: 'Ajouter une réclamation',
      saveToClaimButton: 'Enregistrer'
    },
    replacementItem: {
      title: 'Indemnisation',
      notRepairable: 'Il semble que les dommages ne sont pas réparables.',
      chooseReplacement: 'Veuillez choisir un remplacement :',
      noReplacementText: 'Je ne veux pas de remplacement - Je souhaite parler à un agent. Le délai de traitement de la réclamation risque d’être plus long.',
      noReplacementOptions: 'Malheureusement, il n’existe aucune option de remplacement pour ce bagage. Le remplacement ou la réparation de votre bagage sera traité par un agent ultérieurement.',
      chooseReplacementColour: 'Veuillez sélectionner votre couleur favorite.',
      chooseReplacementAltColour: 'Veuillez sélectionner toute autre couleur que vous accepteriez.',
      disclaimerHeader: 'Avis de non-responsabilité',
      additionalInfo: 'Si vous souhaitez partager plus de détails, vous trouverez un encart pour vos commentaires sur la page suivante.',
      disclaimerText: 'Ceci est une représentation des bagages que vous recevrez. Bien que vous aurez accès aux fonctionnalités décrites ici, il se peut que vos bagages diffèrent en apparence et en style.',
      advisoryText: 'Veuillez noter que le produit de remplacement que vous avez choisi peut être modifié si notre équipe expérimentée estime qu\'il existe un produit plus approprié en remplacement de votre article endommagé. '
    },
    baggageItem: {
      type: 'Type',
      tagNumber: 'N° de l\'étiquette à bagage',
      brand: 'Marque',
      colour: 'Couleur',
      dimensionsIllustration: 'Veuillez mesurer les dimensions de votre bagage du bas vers le haut (roues incluses).',
      dimensionsInfoIconAlt: 'Informations sur les dimensions',
      dimensionsBaggageIconAlt: 'Schéma avec les dimensions du bagage',
      height: 'Hauteur (cm)',
      length: 'Longueur (cm)',
      material: 'Texture',
      proofOfDamagesTitle: 'Preuve des dommages',
      costTitle: 'Coût original',
      datePurchased: 'Date d\'achat',
      receiptNote: 'Ajouter un reçu permet de traiter la réclamation plus rapidement.',
      receiptButton: 'Télécharger un reçu',
      wheels: 'Roues',
      locks: 'Serrures',
      morePhotos: 'Ajouter plus de photos',
      wholeCaseUpload: 'Photo montrant l\'intégralité de la valise ou du sac',
      wholeCaseUploadBuggyType: 'Photo montrant l\'article complet',
      badgeUpload: 'Photo montrant la marque de la valise ou du sac',
      badgeUploadBuggyType: 'Photo montrant le badge de l\'article',
      baggageTagUpload: 'Photo montrant l\'étiquette de bagage(s)',
      areaOfDamageUpload: {
        caption: 'Une photo pour chaque zone endommagée',
        selectPlaceholder: 'Sélectionner le dommage',
        selectOptions: {
          top: 'Haut',
          bottom: 'Bas',
          left: 'Gauche',
          right: 'Droite'
        }
      },
      price: 'Prix',
      isExpandable: 'L\'article est-il extensible ?',
      damageType: 'Type de dommage',
      model: 'Modèle',
      serialNumber: 'Numéro de série'
    },
    contentsItem: {
      name: 'Article endommagé',
      damageDesc: 'Dommage causé',
      proofOfDamagesTitle: 'Preuve des dommages',
      costTitle: 'Coût original',
      datePurchased: 'Date d\'achat',
      receiptNote: 'Ajouter un reçu permet de traiter la réclamation plus rapidement.',
      receiptButton: 'Télécharger un reçu',
      morePhotos: 'Ajouter plus de photos',
      wholeItemUpload: 'Photo montrant l\'intégralité de l\'article endommagé',
      areaOfDamageUpload: {
        caption: 'Photo montrant l\'intégralité de l\'article endommagé',
        selectPlaceholder: 'Sélectionner un dommage',
        selectOptions: {
          top: 'Haut',
          bottom: 'Bas',
          left: 'Gauche',
          right: 'Droite'
        }
      }
    },
    claimsItemsSummary: {
      title: 'Articles existants',
      deleteItemTitle: 'Confirmer la suppression de l\'article',
      deleteConfirmationMessage: 'Êtes-vous sûr(e) de vouloir supprimer l\'article ?',
      addButton: 'Ajouter un article'
    },
    claimsItem: {
      photo: 'photo',
      photos: 'photos',
      receipt: 'reçu ajouté',
      receipts: 'reçus ajoutés',
      deleteItem: 'Supprimer l\'article',
      editItem: 'Modifier l\'article'
    },
    submitClaim: {
      title: 'Envoyer la réclamation',
      additionalInfo: 'Informations supplémentaires',
      additionalInfoPlaceholder: 'Veuillez nous communiquer toute information supplémentaire relative à cette réclamation que vous souhaiteriez que nous prenions en considération.',
      termsCheckboxLabelPrefix: 'J\'accepte les',
      termsCheckboxLabel: 'conditions générales.',
      infoConfirmationCheckboxLabel: 'Je confirme que toutes les informations fournies sont correctes.',
      submitClaimButton: 'Envoyer la réclamation',
      submitClaimError: 'Erreur d\'envoi. Veuillez réessayer.',
      whatsNextTitle: 'Que faire ensuite ?',
      keepLuggageLabelPrefix: 'Veuillez vous assurer de',
      keepLuggageLabel: 'ne pas jeter votre/vos bagage(s) endommagé(s), ',
      keepLuggageLabelSuffix: 'car nous vous demanderons de fournir une preuve photographique.',
      waitForConfirmationLabel: 'Une fois que vous aurez soumis votre réclamation, notre équipe vous contactera pour vous indiquer les prochaines étapes à suivre et les éventuelles preuves à fournir impérativement.',
      infoIconAlt: 'Informations sur le point d\'exclamation',
      requiredBaggageIconAlt: 'Photos exigées du ou des bagages'
    },
    submitSuccess: {
      title: 'Réclamation envoyée',
      header: 'Nous vous remercions d\'avoir envoyé votre réclamation',
      text: 'Votre demande de réclamation est désormais en cours de traitement.',
      refNumber: 'Votre numéro de référence est ',
      emailSoon: 'Vous recevrez bientôt un e-mail confirmant la prochaine étape.',
      buttonText: 'Retour à l\'accueil',
      pageWillCloseTitle: 'Cette page se fermera automatiquement dans',
      pageWillCloseSeconds: 'secondes'
    },
    makeDelayedClaim: {
      title: 'Faire une réclamation pour bagages retardés',
      header: 'Veuillez scanner le code QR ci-dessous puis remplir le formulaire.',
      buttonText: 'Retour au début',
    },
    claimStatus: {
      title: 'État de la réclamation',
      statusPageTitle: 'Résumé de votre réclamation',
      messagesPageTitle: 'Your claim messages',
      claimUpdateItemTitle: 'Ajouter les images demandées',
      summaryHeader: 'Résumé de la réclamation',
      help: 'Pour toute assistance, veuillez répondre ou contacter nous sur www.damagedluggage.com via le Live Chat.',
      phoneIconAlt: 'Aide',
      missingDataIconAlt: 'Erreur',
      missingDataHeading: 'Veuillez compléter les informations manquantes',
      missingDataMessage: 'Des informations supplémentaires sont nécessaires afin de traiter votre réclamation pour les articles suivants :',
      updateClaimButton: 'Mettre à jour la réclamation',
      errorHeader: 'Erreur de chargement',
      errorMessage: 'Une erreur est survenue lors du chargement de l\'état de votre réclamation. Veuillez réessayer.',
      claimRef: 'Claim reference',
      claimMade: 'Date de la réclamation',
      flightDate: 'Date du vol',
      baggageItems: 'Bagages',
      itemNoMissingData: 'Cet article ne présente aucune donnée manquante.',
      replacementItemsRequiresConfirmation: 'Confirmer les articles de remplacement.',
      replacementItemsRequiresConfirmationMessage: 'Veuillez confirmer les articles de remplacement.',
      claimStatusUpdate: 'Mise à jour de l\'état de la réclamation',
      replacementItemsConfirmation: {
        title: 'Articles de remplacement',
        singleItemReplacement: 'Veuillez examiner le remplacement suivant',
        multipleItemReplacement: 'Veuillez examiner les remplacements suivants',
        confirmText: 'Confirmer l\'offre.',
        declineText: 'Refuser l\'offre. Parler à un agent.',
        declineModalTitle: 'Refuser',
        declineModalText: 'Souhaiteriez-vous donner une raison ?',
        declineModalWarning: 'En cas de refus de ce remplacement, le délai de traitement de la réclamation risque d’être plus long.',
        confirmButtonText: 'Confirmer',
        declineButtonText: 'Refuser'
      },
      actionRequiredTitle: 'Action requise',
      actionRequiredText: 'Des informations supplémentaires sont nécessaires afin de poursuivre le traitement de votre demande.',
      titleMessages: 'Dernier message',
      viewMessages: 'Messages',
      newMessage: 'Répondre',
      noMessages: 'Aucun message n’a été ajouté à votre réclamation. Revenez plus tard.',
      messageClientPrefix: 'Me',
      messageAdminPrefix: 'Équipe des bagages endommagés',
      newMessageModalTitle: 'Nouveau message',
      newMessageModalSendButton: 'Envoyer',
      titleDocuments: 'Télécharger un document',
      sendDocument: 'Envoyer le document'
    },
    postcodeLookup: {
      errorMessages: {
        invalid: 'Code postal incorrect. Veuillez réessayer.',
        notFound: 'Code postal introuvable. Veuillez réessayer.'
      },
      defaults: {
        buttonText: 'Rechercher une adresse',
        placeholder: 'Code postal'
      }
    },
    verification: {
      pageTitle: 'Vérification',
      verificationCode: 'Code de vérification',
      sendNewVerificationCode: 'Avez-vous besoin d’un nouveau code de vérification ?',
      newCodeSuccess: 'Veuillez vérifier votre adresse e-mail.',
      newCodeFailed: 'Erreur, veuillez réessayer.'
    },
    screensaver: {
      title: 'Signaler un bagage retardé ou endommagé.',
      selectLanguage: 'Choisir la langue',
      getStarted: 'Commencer'
    },
    apiTranslations: {
      'An invalid code has been entered too many times.\nPlease request a new code and try again.': 'Un code non valide a été saisi trop de fois.\nVeuillez demander un nouveau code et réessayer.',
      'Buggy': 'Buggy',
      'Claim not found.\nPlease contact support for help.': 'Votre réclamation n\'a pas été trouvée.\nVeuillez contacter notre service d\'assistance pour obtenir de l\'aide.',
      'Golf Travel Bag': 'Golf Travel Bag',
      'Hard Shell Golf Case': 'Hard Shell Golf Case',
      'Hard Shell Traditional Style Case' : 'Hard Shell Traditional Style Case ',
      'Hard Shell Trolley Suitcase': 'Hard Shell Trolley Suitcase',
      'Holdall': 'Holdall',
      'Missing claim identifier.\nPlease contact support for help.': 'Identifiant de réclamation manquant.\nVeuillez contacter le service d\'assistance pour obtenir de l\'aide.',
      'Missing verification code.\nPlease contact support for help.': 'Code de vérification manquant.\nVeuillez contacter le service d\'assistance pour obtenir de l\'aide.',
      'Our records show your claim to now be resolved.  You can still get in touch with a message below if you need us.': 'Nos dossiers montrent que votre réclamation est maintenant résolue. Vous pouvez toujours nous contacter en nous laissant un message ci-dessous au besoin.',
      'Please respond to the below message to progress your claim.': 'Veuillez répondre au message ci-dessous pour faire progresser votre réclamation.',
      'RuckSack': 'RuckSack',
      'Soft Shell Trolley Suitcase': 'Soft Shell Trolley Suitcase',
      'This claim has been closed.\nPlease contact support for help.': 'Cette réclamation a été clôturée.\nVeuillez contacter notre service d\'assistance pour obtenir de l\'aide.',
      'This code has now expired.\nPlease request a new code and try again.': 'Ce code est arrivé à expiration.\nVeuillez demander un nouveau code et réessayer.',
      'This code is unrecognised.\nPlease double check your code or request a new code and try again.': 'Ce code n\'est pas reconnu.\nVeuillez vérifier votre code ou demander un nouveau code et réessayer.',
      'Your claim has been passed to our accounts team.  We aim to process payments within 14 working days where possible.': 'Votre réclamation a été transmise à notre équipe de gestion des comptes. Nous visons, dans la mesure du possible, à traiter les paiements dans un délai de 14 jours ouvrables.',
      'Your claim has been rejected as your claim was submitted more than 7 days after the damage date.': 'Votre réclamation a été rejetée car votre réclamation a été soumise plus de 7 jours après la date du dommage.',
      'Your claim has been rejected.': 'Votre réclamation a été rejetée.',
      'Your claim is being handled by our warehouse team who are getting your item ready for despatch.': 'Votre réclamation est traitée par notre équipe d\'entrepôt qui prépare votre article pour l\'expédition.',
      'Your claim is being reviewed, we will be in touch when we have an update for you.': 'Votre réclamation est en cours d\'examen, nous vous contacterons lorsque nous aurons de nouvelles informations à vous communiquer.',
      'Your item has been despatched.': 'Votre article a été expédié.',
      'Your replacement bag is currently out of stock. There is no need for you to do anything at this time we will send your luggage as soon as it is in stock.': 'Votre bagage de remplacement est actuellement en rupture de stock. Vous n\'avez rien à faire pour le moment, nous vous enverrons votre bagage dès qu\'il sera à nouveau disponible.'
    }
  }
}
/* harmony default export */ __webpack_exports__["default"] = (messages);


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.69b1c7c8c1e1fb061761.js